import { render, staticRenderFns } from "./ChessQuestion.vue?vue&type=template&id=ef49c97a&scoped=true"
import script from "./ChessQuestion.vue?vue&type=script&lang=js"
export * from "./ChessQuestion.vue?vue&type=script&lang=js"
import style0 from "./ChessQuestion.vue?vue&type=style&index=0&id=ef49c97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef49c97a",
  null
  
)

export default component.exports